import { format, isBefore, isSameDay } from 'date-fns';

// TODO deprecate
export const formatMessageEventCardDate = (startTime: string | Date, endTime: string | Date) => {
  const start = typeof startTime === 'string' ? new Date(startTime) : startTime;
  const end = typeof endTime === 'string' ? new Date(endTime) : endTime;

  const timezone = start.toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'short' }).substring(4);

  if (isSameDay(start, end)) {
    return `${format(start, 'MMM dd, h:mm')}–${format(end, 'h:mm')}${format(end, 'a').toLowerCase()} ${timezone}`;
  } else {
    return `${format(start, 'MMM dd, h:mm')}${format(start, 'a').toLowerCase()}–${format(end, 'MMM dd, h:mm')}${format(
      end,
      'a',
    ).toLowerCase()} ${timezone}`;
  }
};

export const formatMessageEventCardDates = (startTime: string, endTime: string): { monthDay: string; time: string } => {
  const start = new Date(startTime);
  const end = new Date(endTime);
  const timezone = new Date(startTime)
    .toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'short' })
    .substring(4);

  if (isSameDay(start, end)) {
    // -
    return {
      monthDay: `${format(start, 'eee MMM dd')}`,
      time: `${format(start, 'h:mm')} - ${format(end, 'h:mm')}${format(end, 'a').toLowerCase()} ${timezone}`,
    };
  } else {
    return {
      monthDay: `${format(start, 'eee MMM dd')}`,
      time: `${format(start, 'h:mm')}${format(start, 'a').toLowerCase()} - ${format(end, 'MMM dd')}, ${format(
        end,
        'h:mm',
      )}${format(end, 'a').toLowerCase()} ${timezone}`,
    };
  }
};

export const formatInviteEventDate = (startTime: string, endTime: string): string => {
  const { monthDay, time } = formatMessageEventCardDates(startTime, endTime);
  return `${monthDay}, ${time}`;
};

export const formatEventCardTeaser = (startTime: string, endTime: string): string => {
  try {
    const eventStartDate = new Date(startTime);
    const start = isBefore(eventStartDate, new Date()) ? new Date() : eventStartDate;

    if (!isSameDay(eventStartDate, new Date(endTime))) {
      return `${format(start, 'eeee, LLLL do')} – ${format(new Date(endTime), 'eeee, LLLL do')}`;
    } else {
      return `${format(start, 'eeee, LLLL do')}`;
    }
  } catch {
    return startTime;
  }
};
